import { v4 as uuidv4 } from 'uuid';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RolDto } from '../../../dto/justino/rol.dto';
import { RolService } from '../../../services/rol.service';
import { ModalNomDesComponent } from '../modal-nom-des/modal-nom-des.component';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { SpinnerService } from '../../../services/util/spinner.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseConocimientoDto } from '../../../dto/justino/base-conocimiento.dto';
import { EquipoDto } from '../../../dto/justino/equipo.dto';
import { BaseConocimientoService } from '../../../services/base-conocimiento.service';
import { EquiposService } from '../../../services/equipo.service';
import { HerramientaService } from '../../../services/herramienta.service';
import { ModalInteraccionComponent } from '../modal-interaccion/modal-interaccion.component';
import { InteraccionDto } from '../../../dto/justino/interaccion.dto';
import { HerramientaDto } from '../../../dto/justino/herramienta.dto';
import { EjemploDto } from '../../../dto/justino/ejemplo.dto';
import { ModalEjemploComponent } from '../modal-ejemplo/modal-ejemplo.component';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.scss',
})
export class RolesComponent {
  // Track the current page
  currentPage: number = 1;
  // Track the search term
  searchTerm: string = '';
  // Define la lista de roles
  roles: RolDto[] = [];
  // Define el mensaje sin datos
  mensaje: string = 'No hay datos disponibles.';
  modalNDFlag: boolean = false;
  modalInteraccionFlag: boolean = false;
  modalEjemploFlag: boolean = false;
  listFlag: boolean = true;
  readFlag: boolean = false;
  dilogModelFlag: boolean = false;
  editIneraccionFlag: boolean = false;
  rol!: RolDto;
  isTools: boolean = false;
  interaccionSeleccionada: InteraccionDto | undefined = undefined;
  ejemploSeleccionado: EjemploDto | undefined = undefined;
  editEjemploFlag: boolean = false;
  // Define las bases de conocimiento
  basesConocimiento: BaseConocimientoDto[] = [];
  vertices: string[] = [];
  equipos: EquipoDto[] = [];
  herramientas: HerramientaDto[] = [];
  listaEquipos: EquipoDto[] = [];
  sCinteracciones: InteraccionDto[] = [];
  interacciones: InteraccionDto[] = [
    {
      id: uuidv4(),
      actor: 'Usuario',
      texto: 'Inicia la conversación de manera general',
      interacciones: [],
      tipo: 'Díalogo',
      isExpanded: false,
    },
  ];
  sCejemplos: EjemploDto[] = [];
  ejemplos: EjemploDto[] = [
    {
      actor: 'Usuario',
      texto:
        'Buenos días necesito radicar una demanda pero no se a qué entidad interponerla.',
    },
  ];
  actorEjemplo: string = 'Ninguno';
  rolForm!: FormGroup;
  isReadOnly: boolean = true;
  nomDesForm: any[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'El nombre es requerido',
        pattern:
          'Solo se permiten letras, números y guiones (-). Ejemplo: nombre-1, dos-nombres',
      },
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea1',
      required: true,
      width: '12',
      visible: true,
    },
    {
      name: 'estado',
      label: 'Estado',
      type: 'select1',
      required: true,
      width: '6',
      visible: true,
      errorMessages: { required: 'El estado es obligatorio' },
    },
    {
      name: 'equipo',
      label: 'Equipo',
      type: 'select2',
      required: true,
      width: '6',
      visible: true,
      errorMessages: { required: 'El equipo es obligatorio' },
    },
    {
      name: 'baseConocimiento',
      label: 'Base de conocimiento',
      type: 'select3',
      required: true,
      width: '6',
      visible: true,
      errorMessages: { required: 'La base de conocimiento es obligatorio' },
    },
    {
      name: 'herramienta',
      label: 'Herramienta',
      type: 'select4',
      required: true,
      width: '6',
      visible: true,
      errorMessages: { required: 'La herramienta es obligatoria' },
    },
    {
      name: 'objetivo',
      label: 'Tarea',
      type: 'textarea2',
      required: true,
      width: '12',
      visible: true,
      errorMessages: { required: 'El objetivo es obligatorio' },
    },
    {
      name: 'arquetipo',
      label: 'Arquetipo',
      type: 'textarea3',
      required: true,
      width: '12',
      visible: true,
      errorMessages: { required: 'El arquetipo es obligatorio' },
    },
  ];
  estados = ['Activo', 'Inactivo'];

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'],
    ],
  };

  @ViewChild(ModalNomDesComponent)
  modalND!: ModalNomDesComponent;

  @ViewChild(ModalInteraccionComponent)
  modalInteraccion!: ModalInteraccionComponent;

  @ViewChild(ModalEjemploComponent)
  modalEjemplo!: ModalEjemploComponent;

  constructor(
    private fb: FormBuilder,
    private spinnerService: SpinnerService,
    private rolService: RolService,
    private alertService: AlertaModalService,
    private equipoService: EquiposService,
    private herramientaService: HerramientaService,
    private baseConocimientoService: BaseConocimientoService
  ) {}

  ngOnInit(): void {
    this.loadEquipos();
    this.loadHerramientas();
    this.loadBasesConocimiento();
    this.loadRoles();
    this.createForm();
  }

  loadBasesConocimiento(): void {
    this.baseConocimientoService.getBasesConocimiento().subscribe({
      next: data => {
        this.basesConocimiento = data;
      },
      error: err => {
        this.alertService.error(
          `Error al cargar las bases de conocimiento: ${err.statusText}`
        );
      },
    });
  }

  loadEquipos(): void {
    this.equipoService.getEquipos().subscribe({
      next: data => {
        this.equipos = data;
      },
      error: err => {
        this.alertService.error(
          `Error al cargar los equipos: ${err.statusText}`
        );
      },
    });
  }

  loadHerramientas(): void {
    this.herramientaService.getHerramientas().subscribe({
      next: data => {
        this.herramientas = data;
      },
      error: err => {
        this.alertService.error(
          `Error al cargar las herramientas: ${err.statusText}`
        );
      },
    });
  }

  loadRoles(): void {
    this.rolService.getRoles().subscribe({
      next: data => {
        this.roles = data;
      },
      error: err => {
        this.alertService.error(`Error al cargar los roles: ${err.statusText}`);
      },
    });
  }

  cargarVertices(interacciones: InteraccionDto[]): void {
    interacciones.forEach(interaccion => {
      // Verifica si la interacción ya fue marcada
      if (this.vertices.includes(interaccion.id)) {
        return;
      }
      // Marca la interacción como visitada
      this.vertices.push(interaccion.id);
      this.cargarVertices(interaccion.interacciones);
    });
  }

  editarRol(rol: RolDto) {
    this.rol = rol;
    this.listFlag = false;
    this.readFlag = true;
    this.isReadOnly = false;
    this.isTools = false;
    this.loadEjemplos();
    if (this.rol.Interacciones) {
      this.interacciones = this.rol.Interacciones;
      this.vertices = [];
      this.cargarVertices(this.interacciones);
    }
    this.createForm();
    this.fillFormWithData();
    if (this.isReadOnly) {
      this.rolForm.disable();
    } else {
      this.rolForm.enable();
    }
  }

  loadEjemplos() {
    this.ejemplos = [];
    if (
      this.rol.Ejemplo !== undefined &&
      this.rol.Ejemplo !== '' &&
      this.rol.Ejemplo !== null
    ) {
      const regex = /\[(.*?)\]:\s?(.*)/g;
      let match;
      while ((match = regex.exec(this.rol.Ejemplo)) !== null) {
        this.ejemplos.push({
          actor: match[1].trim(),
          texto: match[2].trim(),
        });
      }
      // Ontiene el ultimo elemento de la lista de ejemplos
      this.actorEjemplo = this.ejemplos[this.ejemplos.length - 1].actor;
    }
  }

  eliminarRol(id: string) {
    this.alertService.confirmacion(
      '¿Desea eliminar el rol?',
      'Eliminar',
      () => {
        this.rolService.deleteRol(id).subscribe({
          next: () => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Rol eliminado correctamente'
            );
            this.loadRoles();
          },
          error: err => {
            this.spinnerService.hideSpinner();
            this.alertService.error(
              `Error al eliminar el rol: ${err.statusText}`
            );
          },
        });
      },
      () => {}
    );
  }

  registrarRol(dto: any) {
    const nuevoNombre = dto.nombre;
    const nuevoDescripcion = dto.descripcion;
    this.modalND.abrirCerrarModal();
    if (nuevoNombre && nuevoNombre.trim() !== '') {
      const nuevoRol: RolDto = {
        Id: '0',
        Nombre: nuevoNombre,
        Descripcion: nuevoDescripcion,
        Estado: 'Activo',
        Equipo: undefined,
        BaseConocimiento: undefined,
        FechaCreacion: new Date().toISOString(),
        FechaModificacion: new Date().toISOString(),
        UsuarioCreacion: 'admin',
        UsuarioModificacion: 'admin',
        Interacciones: [],
      };
      this.rolService.createRol(nuevoRol).subscribe({
        next: () => {
          this.spinnerService.hideSpinner();
          this.alertService.exito(
            'Mensaje informativo',
            'Rol creado correctamente'
          );
          this.loadRoles();
        },
        error: err => {
          this.spinnerService.hideSpinner();
          this.alertService.error(`Error al crear el rol ${err.statusText}`);
        },
      });
    }
  }

  async crearRol() {
    this.abrirModalND();
  }

  abrirModalND() {
    this.modalNDFlag = true;
    setTimeout(() => {
      this.modalND.abrirCerrarModal();
    }, 500);
  }

  abrirModalInteraccion() {
    this.modalInteraccionFlag = true;
    setTimeout(() => {
      this.modalInteraccion.abrirCerrarModal();
    }, 500);
  }

  abrirModalInteraccionCrear() {
    this.modalInteraccionFlag = true;
    setTimeout(() => {
      this.modalInteraccion.abrirCrear(this.interaccionSeleccionada);
    }, 500);
  }

  abriModalInteraccionActualizar(interaccion: InteraccionDto) {
    this.modalInteraccionFlag = true;
    setTimeout(() => {
      this.modalInteraccion.abrirActualizar(interaccion);
    }, 500);
  }

  abrirModalEjemplo() {
    this.modalEjemploFlag = true;
    setTimeout(() => {
      this.modalEjemplo.abrirCerrarModal();
    }, 500);
  }

  onRowClick(rol: RolDto) {
    this.rol = rol;
    this.listFlag = false;
    this.readFlag = true;
    this.isReadOnly = this.readFlag;
    this.isTools = false;
    this.loadEjemplos();
    if (this.rol.Interacciones) {
      this.interacciones = this.rol.Interacciones;
    }
    this.createForm();
    this.fillFormWithData();
    if (this.isReadOnly) {
      this.rolForm.disable();
    } else {
      this.rolForm.enable();
    }
  }

  volverElemento() {
    this.dilogModelFlag = false;
    this.listFlag = true;
    this.readFlag = false;
    this.isReadOnly = this.readFlag;
    this.rolForm.reset();
  }

  createForm(): void {
    const equipo = this.equipos.find(e => e.Id === this.rol.Equipo);
    if (
      equipo?.Nombre === 'Web' ||
      equipo?.Nombre === 'Especialistas' ||
      equipo?.Nombre === 'Funcionalidades'
    ) {
      this.dilogModelFlag = true;
    } else if (equipo?.Nombre === 'Operadores') {
      this.isTools = true;
    }
    const formControls: any = {};
    this.nomDesForm.forEach(field => {
      if (
        field.name != 'herramienta' ||
        (field.name === 'herramienta' && this.isTools)
      ) {
        const validators = [];
        if (field.required) {
          validators.push(Validators.required);
        }
        if (field.name === 'nombre') {
          validators.push(Validators.pattern(/^[a-zA-Z0-9-]+$/));
        }
        formControls[field.name] = [null, validators];
      }
    });
    this.rolForm = this.fb.group(formControls);
    if (this.isReadOnly) {
      this.rolForm.disable();
    }
  }

  fillFormWithData(): void {
    if (this.rol) {
      const baseConocimiento = this.basesConocimiento.find(
        b => b.Id === this.rol.BaseConocimiento
      );
      this.rolForm.patchValue({
        nombre: this.rol.Nombre,
        descripcion: this.rol.Descripcion,
        estado: this.rol.Estado,
        equipo: this.rol.Equipo,
        baseConocimiento: baseConocimiento ? baseConocimiento.Id : null,
        objetivo: this.rol.Objetivo,
        arquetipo: this.rol.Arquetipo,
        ejemplo: this.rol.Ejemplo,
        herramienta: this.rol.Herramienta,
      });
      if (this.rol.Interacciones && this.rol.Interacciones.length > 0) {
        this.interacciones = this.rol.Interacciones;
        this.vertices = [];
        this.cargarVertices(this.interacciones);
      }
      // Obtiene una copia de la lista de equipos en listaEquipos
      // sin el equipo actual
      this.listaEquipos = this.equipos.filter(e => e.Id !== this.rol.Equipo);
    }
  }

  onChangeEquipo(event: any) {
    const equipo = this.equipos.find(e => e.Id === event.target.value);
    if (
      equipo?.Nombre === 'Web' ||
      equipo?.Nombre === 'Especialistas' ||
      equipo?.Nombre === 'Funcionalidades'
    ) {
      // Elimina el control de herramienta al formulario
      this.rolForm.removeControl('herramienta');
      this.dilogModelFlag = true;
      this.isTools = false;
    } else if (equipo?.Nombre === 'Operadores') {
      // Adiciona control de herramienta al formulario
      this.rolForm.addControl(
        'herramienta',
        this.fb.control(null, [Validators.required])
      );
      this.isTools = true;
      this.dilogModelFlag = false;
    } else {
      // Elimina el control de herramienta al formulario
      this.rolForm.removeControl('herramienta');
      this.dilogModelFlag = false;
      this.isTools = false;
    }
    this.listaEquipos = this.equipos.filter(e => e.Id !== event.target.value);
  }

  crearInteraccion() {
    //this.interaccionSeleccionada = undefined;
    this.abrirModalInteraccionCrear();
  }

  getErrorMessage(field: string): string | null {
    const control = this.rolForm.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      return (
        this.nomDesForm.find(f => f.name === field)?.errorMessages?.[
          errorType
        ] || 'Campo inválido'
      );
    }
    return null;
  }

  toggleEdit(): void {
    this.isReadOnly = !this.isReadOnly;
    if (this.isReadOnly) {
      this.rolForm.disable();
    } else {
      this.rolForm.enable();
    }
    this.interaccionSeleccionada = undefined;
    // Itera el array de insteracciones sin confirmar para eliminarlas
    this.sCinteracciones.forEach(i => {
      this.onInteraccionEliminar(i);
    });
    this.sCinteracciones = [];
    // Itera el array de ejemplos sin confirmar para eliminarlas
    this.sCejemplos.forEach(e => {
      this.onEjemploEliminar(e);
    });
    this.sCejemplos = [];
  }

  isNameUnique(name: string): boolean {
    return !this.roles.some(
      el => el.Nombre.toLowerCase() === name.toLowerCase()
    );
  }

  submitForm(): void {
    if (this.rolForm.valid) {
      const dto = this.rolForm.value;
      if (this.rol.Nombre != dto.nombre) {
        if (!this.isNameUnique(dto.nombre)) {
          this.alertService.error(
            'Error al actualizar el rol',
            'El nombre ya existe'
          );
          return;
        }
      }
      this.rol.Nombre = dto.nombre;
      this.rol.Descripcion = dto.descripcion;
      this.rol.Estado = dto.estado;
      this.rol.Equipo = dto.equipo;
      this.rol.BaseConocimiento = dto.baseConocimiento;
      if (this.dilogModelFlag) {
        this.rol.Interacciones = this.interacciones;
      }
      this.rol.Objetivo = dto.objetivo;
      this.rol.Arquetipo = dto.arquetipo;
      this.rol.Ejemplo = this.ejemplos
        .map(e => `[${e.actor}]: ${e.texto}`)
        .join('\n');
      this.rol.Herramienta = dto.herramienta;
      this.rolService.updateRol(this.rol.Id, this.rol).subscribe({
        next: () => {
          this.spinnerService.hideSpinner();
          this.alertService.exito(
            'Mensaje informativo',
            'Rol actualizado correctamente'
          );
          this.loadRoles();
          this.sCinteracciones = [];
          this.sCejemplos = [];
        },
        error: err => {
          this.spinnerService.hideSpinner();
          this.alertService.error(
            `Error al actaulizar el rol: ${err.statusText}`
          );
        },
      });
      this.isReadOnly = true;
      this.rolForm.disable();
    } else {
      this.rolForm.markAllAsTouched();
    }
  }

  onInteraccionSeleccionada(interaccion: InteraccionDto) {
    this.editIneraccionFlag = false;
    this.interaccionSeleccionada = interaccion;
  }

  onInteraccionActualizar(interaccion: InteraccionDto) {
    this.editIneraccionFlag = true;
    this.interaccionSeleccionada = interaccion;
    this.abriModalInteraccionActualizar(interaccion);
  }

  interaccionActualizada(interaccion: InteraccionDto) {
    this.modalInteraccion.abrirCerrarModal();
    this.editIneraccionFlag = false;
  }

  ejemploActualizado(ejemplo: EjemploDto) {
    this.modalEjemplo.abrirCerrarModal();
    this.editEjemploFlag = false;
  }

  buscarPadre(
    interacciones: InteraccionDto[],
    interaccion: InteraccionDto
  ): InteraccionDto[] {
    let results: InteraccionDto[] = [];
    for (let i = 0; i < interacciones.length; i++) {
      if (interacciones[i].texto === interaccion.texto) {
        return interacciones;
      } else {
        results = this.buscarPadre(interacciones[i].interacciones, interaccion);
        if (results.length > 0) {
          return results;
        }
      }
    }
    return results;
  }

  onInteraccionAgregar(interaccion: InteraccionDto) {
    this.interaccionSeleccionada = interaccion;
    this.abrirModalInteraccionCrear();
  }

  onInteraccionEliminar(interaccion: InteraccionDto) {
    let index = -1;
    // Buscar en forma recursiva (profundidad) la interacción en la lista de interacciones
    let interaccionesPadre = this.buscarPadre(this.interacciones, interaccion);
    if (interaccionesPadre.length === 0) {
      // Se trata de una interacción padre
      index = this.interacciones.findIndex(i => i.texto === interaccion.texto);
      if (index > -1) {
        this.interacciones.splice(index, 1);
      }
    } else {
      // Se trata de una interacción hija
      index = interaccionesPadre.findIndex(i => i.texto === interaccion.texto);
      if (index > -1) {
        interaccionesPadre.splice(index, 1);
      }
    }
  }

  adicionarInteraccion(dto: any) {
    const nuevoTexto = dto.texto;
    let nuevoTipo = dto.tipo;
    const nuevaHerramienta = dto.herramienta;
    let nuevoEquipo = dto.equipo;
    let nuevoActor = dto.actor;
    this.modalInteraccion.abrirCerrarModal();
    if (nuevoTexto && nuevoTexto.trim() !== '') {
      if (nuevoTipo === 'Respuesta de equipo') {
        nuevoEquipo = this.interaccionSeleccionada?.equipo;
      } else if (nuevoTipo === 'Retorno') {
        nuevoTipo = 'Díalogo';
        nuevoActor = 'Sistema';
      }
      const nuevaInteraccion: InteraccionDto = {
        id: uuidv4(),
        texto: nuevoTexto,
        actor: nuevoActor,
        tipo: nuevoTipo,
        herramienta: nuevaHerramienta,
        equipo: nuevoEquipo,
        interacciones: [],
        isExpanded: false,
      };
      if (
        nuevoTipo === 'Salta a' &&
        (!nuevoTexto || !nuevoTexto.includes('Salta a:'))
      ) {
        this.alertService.error(
          'Error al adicionar interacción',
          'Se debe seleccionar un paso de la conversación'
        );
        return;
      }
      // La registra como interaccion sin confirmar
      this.sCinteracciones.push(nuevaInteraccion);
      // Verificar si la interacción es la iniciadora de la conversación
      if (this.interaccionSeleccionada === undefined) {
        // Se agrega la interacción iciadora de la conversación
        this.interacciones.push(nuevaInteraccion);
      } else {
        // Verificar si la interacción seleccionada esta asociada al actor Usuario
        if (this.interaccionSeleccionada.actor === 'Des. Usuario') {
          // Verifica si la interacción seleccionada no tiene interacciones
          if (this.interaccionSeleccionada.interacciones.length === 0) {
            this.interaccionSeleccionada.interacciones.push(nuevaInteraccion);
          } else {
            nuevaInteraccion.actor = 'Instrucción';
            this.interaccionSeleccionada.interacciones.push(nuevaInteraccion);
          }
        } else {
          // Agregar la interacción a la insteracción seleccionada
          this.interaccionSeleccionada.interacciones.push(nuevaInteraccion);
        }
        this.interaccionSeleccionada.isExpanded = true;
      }
    }
  }

  adicionarEjemplo(dto: any) {
    const nuevoActor = dto.actor;
    const nuevaDescripcion = dto.texto;
    this.modalEjemplo.abrirCerrarModal();
    if (nuevaDescripcion && nuevaDescripcion.trim() !== '') {
      const nuevoEjemplo: EjemploDto = {
        actor: nuevoActor,
        texto: nuevaDescripcion,
      };
      this.ejemplos.push(nuevoEjemplo);
      this.sCejemplos.push(nuevoEjemplo);
      this.actorEjemplo = nuevoActor;
    }
  }

  crearEjemplo() {
    this.ejemploSeleccionado = undefined;
    this.abrirModalEjemplo();
  }

  onEjemploActualizar(ejemplo: EjemploDto) {
    this.editEjemploFlag = true;
    this.ejemploSeleccionado = ejemplo;
    this.abrirModalEjemplo();
  }

  onEjemploEliminar(ejemplo: EjemploDto) {
    let index = this.ejemplos.findIndex(e => e.texto === ejemplo.texto);
    if (index > -1) {
      this.ejemplos.splice(index, 1);
    }
  }
}
